import React, { FC } from 'react';

import { Tooltip, Typography, TypographyProps } from '@mui/material';

type Props = TypographyProps & {
  tooltip?: string;
};

const ActivityLogText: FC<Props> = (props) => {
  const {
    children,
    tooltip,
    fontWeight = 400,
    component = 'span',
    variant = 'body2',
    color = 'text.secondary',
    ...rest
  } = props;
  return (
    <Typography component={component} fontWeight={fontWeight} color={color} variant={variant} {...rest}>
      {!tooltip && children}
      {tooltip && children && (
        <Tooltip title={tooltip}>
          <span>{children}</span>
        </Tooltip>
      )}
    </Typography>
  );
};

export default ActivityLogText;
